import axios from 'axios';
import { GET_GLOBAL_NOTIFICATION_MESSAGES_ENDPOINT } from '../constants/endpoint';

export const GetGlobalNotificationMessages = async () => axios.get(`${GET_GLOBAL_NOTIFICATION_MESSAGES_ENDPOINT}`);

export const RemoveGlobalNotificationMessage = async () => axios.delete(`${GET_GLOBAL_NOTIFICATION_MESSAGES_ENDPOINT}`);
